import { ContainerModule, interfaces } from 'inversify';
import AnnouncementsController from './announcements.controller';
import { ANNOUNCEMENTS_MODULE_IDS } from './announcements.const';
import { ANNOUNCEMENTS_EVENTS } from './announcements.events';


const AnnouncementsModule = new ContainerModule(
  (bind: interfaces.Bind) => {
    bind(ANNOUNCEMENTS_MODULE_IDS.ANNOUNCEMENTS_CONTROLLER)
      .to(AnnouncementsController)
      .inSingletonScope();
    bind(ANNOUNCEMENTS_MODULE_IDS.ANNOUNCEMENTS_EVENTS).toConstantValue(ANNOUNCEMENTS_EVENTS);
  },
);

export { AnnouncementsModule };
